import { useCallback, useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';
import { Spinner } from '../../../../../components/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGhost } from '@fortawesome/free-solid-svg-icons';

function ConsumerPopoverGhostForm({ consumerId, refresh }) {
  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [allGhosting, setAllGhosting] = useState([]);

  const getAllGhosting = useCallback(async () => {
    setSpinner(true);

    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = { token, url: `${apiOriginConsumer}/get_all_ghosting` };

    try {
      const response = await makeRequest(config);

      setAllGhosting(response);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  }, [apiOriginConsumer, getAccessTokenSilently]);

  useEffect(() => {
    if (isOpen) {
      getAllGhosting();
    }
  }, [isOpen, getAllGhosting]);

  const handleToggle = () => {
    setAllGhosting([]);
    setIsOpen(!isOpen);
  };

  const ghostConsumer = async ghostingConsumerId => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginConsumer}/ghost`,
      method: 'POST',
      data: JSON.stringify({ ghostingConsumerId, ghostedConsumerId: consumerId }),
    };

    try {
      await makeRequest(config);
      // eslint-disable-next-line no-promise-executor-return
      await new Promise(resolve => setTimeout(resolve, 1000));

      refresh();
      handleToggle();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 6] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu bo-w-225">
            <Spinner visible={spinner} size={36}>
              <Form.Label className="bo-common-popover-form-menu-label">
                Select Ghosting User:
              </Form.Label>
              <div className="bo-h-150-fixed overflow-auto bo-table-container">
                {allGhosting.map(x => (
                  <div key={x.consumerId} className="mt-2 d-flex align-items-center">
                    <Button
                      className="text-start bo-common-inline-button text-decoration-none"
                      onClick={() => ghostConsumer(x.consumerId)}
                    >
                      {`${x.firstName} ${x.lastName}`}
                    </Button>
                    <div className="ms-auto me-2 bo-min-w-32 text-end">
                      {x.isGhostingNow && (
                        <FontAwesomeIcon icon={faGhost} size="sm" color="#DC3545" />
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-2 d-flex justify-content-center">
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      <Button className="bo-common-inline-button" onClick={handleToggle}>
        Ghost
      </Button>
    </OverlayTrigger>
  );
}

export default ConsumerPopoverGhostForm;
